<template>
  <div id="ContactPage">
    <p><span class="textSite">Camber Strategic Partners</span><br/>
       20693 Raisnboro Drive<br/>
       Ashburn, VA 20147<br/><br/>

       Email: dean.hawes@camberstrategic.com<br/>
       Phone: 703-862-5721</p>
  </div>
</template>

<script>
export default {
  name: 'ContactPage'
}
</script>

<style>
  .textSite {
    font-size: 1.5em;
    font-weight: bold;
    color: rgb(0, 84, 149);
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ContactPage.vue